import HomePage from '@/pages/home';

export const IndexRoute = () => {
  return <HomePage />;
};
